import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classNames from 'classnames';
import { cancelTrade } from '../paymentActions.js';
import partnerPropTypes from '../../../partnerPropTypes';
import agreementPropTypes from '../../../agreementPropTypes.js';
import Page from '../../../page.jsx';

const HandleCancelPurchaseDetails = ({
    agreement,
    partner,
    handleClickCancelPurchase,
}) => (
    <Page heading="Vil du heve kjøpet?">
        <div className="phl">
            <div className="pbl">
                <p>
                    Hvis du hever kjøpet, bryter du en avtale du har inngått med{' '}
                    {partner.name}, og FINN vil tilbakebetale hele beløpet til{' '}
                    {partner.name}.
                </p>
                <p>
                    {partner.name} vil kunne gi deg en vurdering som vil være
                    synlig på din profil.
                </p>
            </div>

            <div className="centerify">
                <div className="r-phl r-ptl">
                    <button
                        className={classNames('primary fullwidth', {
                            inprogress: agreement.loading,
                        })}
                        disabled={agreement.loading}
                        onClick={handleClickCancelPurchase}
                    >
                        Ja, hev kjøpet
                    </button>
                </div>

                <div className="r-pal">
                    <Link to="/samtale" className="button fullwidth">
                        Avbryt
                    </Link>
                </div>
            </div>
        </div>
    </Page>
);

HandleCancelPurchaseDetails.propTypes = {
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    partner: partnerPropTypes.isRequired,
    agreement: agreementPropTypes.isRequired,
    handleClickCancelPurchase: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement,
        itemId: state.safeTrade.itemId,
        itemType: state.safeTrade.itemType,
        partner: state.partner,
    };
}

const mapDispatchToProps = { handleClickCancelPurchase: cancelTrade };

function mergeProps(stateProps, dispatchProps, ownProps) {
    const { itemType, itemId, partner } = stateProps;

    return {
        ...ownProps,
        ...stateProps,
        handleClickCancelPurchase: () =>
            dispatchProps.handleClickCancelPurchase({
                itemType,
                itemId,
                partnerId: partner.id,
            }),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
    HandleCancelPurchaseDetails
);



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/statusDetails/handleCancelPurchaseDetails.jsx